import { memo } from "react";
import { MiStackedTypography } from "@miplatform/components";
import { formatDate } from "@miplatform/utils";
import { Box } from "@mui/material";
import { ORDERS_DEFAULT_FIELD_WIDTH } from "../../ordersConstants";
import { OrdersListActionMenu } from "../ActionMenu/OrdersListActionMenu";

/**
 * AssignedOrderActions Component
 *
 * A React functional component that displays the actions available for a assigned order.
 *
 * @component
 * @param {Object} props - Component props.
 *
 * @returns {JSX.Element} The rendered AssignedOrderActions component.
 */
export const AssignedOrderActions = memo((props) => {
  const { approvedStartDate, assignedDate } = props;
  return (
    <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
      <MiStackedTypography
        title="Approved Date"
        titleProps={{ width: ORDERS_DEFAULT_FIELD_WIDTH }}
        description={
          approvedStartDate ? formatDate(approvedStartDate, "MM/DD/YYYY") : "--"
        }
        descriptionProps={{ width: ORDERS_DEFAULT_FIELD_WIDTH }}
      />
      <MiStackedTypography
        title="Assigned Date"
        titleProps={{ width: ORDERS_DEFAULT_FIELD_WIDTH }}
        description={
          assignedDate ? formatDate(assignedDate, "MM/DD/YYYY") : "--"
        }
        descriptionProps={{ width: ORDERS_DEFAULT_FIELD_WIDTH }}
      />
      <OrdersListActionMenu
        menuViewConfig={{
          Reschedule: true,
          Hold: true,
          Cancel: true,
          OrderActivityDetails: true,
          ForceComplete: true,
          UndoAssignment: true,
        }}
        {...props}
      />
    </Box>
  );
});
